// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"6f678305","850":"ddb320c4"}[chunkId] + ".chunk.js";
};